import {
  ComponentWithOptionalMetadata,
  GetMetadataFunction,
} from 'mkt-ssr/lib/page/metadata/types';

export * from 'mkt-ssr/lib/page/metadata/types';
export * from 'mkt-ssr/lib/page/metadata/context';

export function defineMetadata<P>(
  Component: ComponentWithOptionalMetadata<P>,
  metadataGenerator: GetMetadataFunction<P>,
) {
  Component.getMetadata = metadataGenerator;
}
